import script from "./whitelist-section.vue?vue&type=script&setup=true&lang=ts"
export * from "./whitelist-section.vue?vue&type=script&setup=true&lang=ts"

import "./whitelist-section.vue?vue&type=style&index=0&id=2e4177c2&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e4177c2"]])

export default __exports__